import { QueryClientProvider, QueryClient } from '@tanstack/react-query'
import React from 'react'
import ActivityNavProvider from '../components/CarouseledActivityGroupWrapper/ActivityNavProvider'
import ActivityGroupProvider from './ActivityGroupProvider'
import AvatarsProvider from './AvatarsProvider'
import FamilyGroupProvider from './FamilyGroupProvider'
import TopicProvider from './TopicProvider'
import UserDetailsProvider from './UserDetailsProvider'

const queryClient = new QueryClient()

export default function Providers({ children }) {
  return (
    <QueryClientProvider client={queryClient}>
      <TopicProvider>
        <UserDetailsProvider>
          <FamilyGroupProvider>
            <ActivityNavProvider>
              <ActivityGroupProvider>
                <AvatarsProvider>{children}</AvatarsProvider>
              </ActivityGroupProvider>
            </ActivityNavProvider>
          </FamilyGroupProvider>
        </UserDetailsProvider>
      </TopicProvider>
    </QueryClientProvider>
  )
}
